export const queryKeys = {
  ACTIVE_SHIPMENTS: 'active-shipments',
  ACTIVE_SHIPMENT_DETAILS: 'active-shipment-details',
  ALIASES: 'aliases',
  ALLOWED_CARRIERS: 'allowed-carriers',
  AMENDMENT_DETAILS: 'amendment-details',
  AMENDMENT_IMPORT_PROGRESS: 'amendment-import-progress',
  AMENDMENT_LEG_CHANGES_LIST: 'amendment-leg-changes-list',
  AMENDMENT_VALIDATION_ERRORS: 'amendment-validation-errors',
  COMMODITIES: 'commodities',
  COMPANIES: 'companies',
  COMPANIES_FILE_EXPORT: 'companies-file-export',
  CONTRACTS: 'contracts',
  CONTRACT_CODES: 'contract-codes',
  CONTRACT_CODES_ALL_LIST_SEARCH: 'contract-codes-all-list-search',
  CONTRACT_CODES_LIST_SEARCH: 'contract-codes-list-search',
  CONTRACT_DETAILS: 'contract-details',
  CONTRACT_IMPORT_PROGRESS: 'contract-import-progress',
  CONTRACT_LEGS: 'contract-legs',
  CONTRACT_LEGS_LOCATION: 'contract-legs-location',
  CONTRACT_LEG_DETAILS: 'contract-leg-details',
  CONTRACT_LEG_HISTORY: 'contract-leg-history',
  CONTRACT_VALIDATION_ERRORS: 'contract-validation-errors',
  CONTRACT_YEARS: 'contract-years',
  CREDITABLE_CORRECTIONS: 'creditable-corrections',
  CREDITABLE_SHIPMENTS: 'creditable-shipments',
  CREDITS: 'credits',
  CREDIT_DETAILS: 'credit-details',
  CREDIT_SHIPMENTS: 'credit-shipments',
  ENV_CONFIG: 'env-config',
  EXCHANGE_RATES: 'exchange-rates',
  IMPORT_SHIPMENTS: 'import-shipments',
  IMPORT_SHIPMENT_DETAILS: 'import-shipment-details',
  INVOICABLE_SHIPMENTS: 'invoicable-shipments',
  INVOICES: 'invoices',
  INVOICE_DETAILS: 'invoice-details',
  INVOICE_SHIPMENTS: 'invoice-shipments',
  LEG_EQUIPMENT_TYPE_OPTIONS: 'leg-equipment-type-options',
  LEG_MODALITY_OPTIONS: 'leg-modality-options',
  LOGIN: 'login',
  NEWS: 'news',
  NEWS_FIELDS: 'news-fields',
  NEWS_FIELDS_FILE_LIST: 'news-file-list',
  NOTIFICATION_SETTINGS: 'notification-settings',
  PORTALS: 'portals',
  PRIVILEGES_LIST: 'privileges-list', // the result of this is the list of news that we have
  REPORT_DETAILS: 'report-details',
  REPORT_IMPORT_PROGRESS: 'report-import-progress',
  REPORT_PICKER: 'report-picker',
  REPORT_VALIDATION_ERRORS: 'report-validation-errors',
  SEARCH_CARRIERS: 'search-carriers',
  SEARCH_INSTANCE: 'search-instance',
  SEARCH_LOCATION: 'search-location',
  SEARCH_RESULTS_LIST: 'search-results-list',
  SEARCH_RESULT_ITEM_DETAILS: 'search-result-item-details',
  SHIPMENT_HISTORY: 'shipment-history',
  TEMPLATE_LEGS: 'template-legs',
  TEMPLATE_LEGS_IMPORT_ERRORS: 'template-legs-import-errors',
  TEMPLATE_LEGS_LOCATION: 'template-legs-location',
  TOTP_STATUS: 'totp-status',
  TENDERS: 'tenders',
  TENDER_DEFAULT_FIELDS: 'tender-default-fields',
  TENDER_DETAILS: 'tender-details',
  TENDER_IMPORT_PROGRESS: 'tender-import-progress',
  TENDER_LEGS: 'tender-legs',
  TENDER_LEG_DETAILS: 'tender-leg-details',
  TENDER_LOCATION: 'tender-location',
  TENDER_STATUSES: 'tender-statuses',
  TIERS: 'tiers',
  TIER_COSTS: 'tier-costs',
  UNLOCODES: 'unlocodes',
  UNLOCODES_IN_UNLOCODE_GROUP: 'unlocodes-in-unlocode-group',
  UNLOCODE_GROUPS: 'unlocode-groups',
  UPDATE_UNLOCODES_IN_UNLOCODE_GROUP: 'unlocodes-in-unlocode-group',
  USERS: 'users',
  USER_DEFAULT_FIELDS: 'user-default-fields',
  USER_LOGS: 'user-logs',
  USER_LOGS_FILE_EXPORT: 'user-logs-file-export',
  USER_PREFERENCES_DISPLAY: 'user-preferences-display',
  VERIFY_TOKEN: 'verify-token',
  VID_BATCHABLE_CORRECTIONS: 'vid-batchable-corrections',
  VID_BATCHABLE_SHIPMENTS: 'vid-batchable-shipments',
  VID_BATCHES: 'vid-batches',
  VID_BATCH_DETAILS: 'vid-batch-details',
  VID_BATCH_ROWS: 'vid-batch-rows',
  VID_TOP_UPABLE_SHIPMENTS: 'vid-top-upable-shipments',
};
